// src/config/moduleAreas.ts
// Mapa central MÓDULO de tenant → ÁREAS do frontend (espelho do ADR-017 do
// backend). Fonte única da verdade do gate de UX: ajustar AQUI quando o backend
// mudar a composição de um módulo.
//
// "Área" = a chave usada pelo front para identificar uma seção:
//   - sufixo da permissão de card na Home (`modulo.<area>`),
//   - id da aba no form de permissões (MODULE_TABS),
//   - sufixo da permissão de rota no ProtectedRoute.
//
// ⚠️ Mapa provisório (ADR-017 do backend) — pode mudar quando a app estabilizar.

import type { TenantModule } from '../types/entitlement';

export const MODULE_AREA_MAP: Record<TenantModule, string[]> = {
  // Requisições, Ordens de Compra, Cotação, Conferência/Recebimento/Pré-ordem,
  // Contatos da integração e Parâmetros de aprovação são todos PO no backend.
  PO: ['requisicoes', 'gestao_compras', 'gestao_conferencias', 'contatos'],
  // Gate ligado desde já (admin governa o release/block por tenant): o card/aba
  // só aparece quando `GET /v1/entitlement/features` trouxer o código. Enquanto o
  // módulo não é provisionado, some — comportamento correto e governado pelo admin.
  ODP: ['planejamento'],
  CD: ['gestao_transferencias'],
  AERP: [],
  // Diferente das outras áreas desta lista, 'bluebi' TAMBÉM gateia rota (`/bluebi` em
  // ProtectedRoute): a ADR-023 dizia que ODP/CD/BBI só afetavam cards da Home e abas do
  // form porque tinham `route: ''`, o que deixou de valer quando o módulo ganhou tela
  // (ADR-037).
  BBI: ['bluebi'],
};

// Índice reverso área → módulo, construído uma vez na carga do módulo.
const AREA_TO_MODULE: Record<string, TenantModule> = Object.entries(MODULE_AREA_MAP).reduce(
  (acc, [mod, areas]) => {
    areas.forEach((area) => {
      acc[area] = mod as TenantModule;
    });
    return acc;
  },
  {} as Record<string, TenantModule>
);

// Retorna o módulo de tenant dono de uma área do front, ou `null` quando a área
// não pertence a nenhum módulo gateado (= sempre visível, sem gate).
export const moduleForArea = (area: string): TenantModule | null => AREA_TO_MODULE[area] ?? null;
